import { useContext } from 'react';
import { ViewMessageContext, ViewMessageContextType } from 'src/sections/view_message/ViewMessageContextUnified';

/**
 * Hook to access the unified ViewMessage context.
 * All message-related components (inbox, outbox, compose) use this single unified context.
 * 
 * @returns ViewMessageContextType - The unified message context
 * @throws Error if used outside ViewMessageContextProvider
 */
const useViewMessage = (): ViewMessageContextType => {
  const context = useContext(ViewMessageContext);
  
  if (!context || Object.keys(context).length === 0) {
    throw new Error('useViewMessage must be used within a ViewMessageContextProvider');
  }
  
  return context;
};

export default useViewMessage;